import type React from 'react';
import { Breadcrumbs } from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import SettingStyles from '../../SettingStyle.module.scss';
import { PATH } from '~/pages/vendors/settings';
import { SurveySetting } from '~/components/specifics/vendors/settings/surveys/index/SurveySetting';

export const Page: React.FC = () => (
  <VendorLayoutV2>
    <VendorSettingLayout>
      <div className={SettingStyles.SpBreadcrumbsWrapper}>
        <Breadcrumbs
          items={[
            { label: '設定一覧', as: Link, href: PATH },
            { label: 'アンケート設定' }
          ]}
        />
      </div>
      <SurveySetting />
    </VendorSettingLayout>
  </VendorLayoutV2>
);
